import { ThemeSwitcher } from '@features/theme/theme-switcher';
import s from './appearance-settings.module.scss';

export const AppearanceSettings = () => {
	return (
		<div className={s.wrapper}>
			<div className={s.title}>Внешний вид</div>
			<div className={s.card}>
				<div className={s.row}>
					<div className={s.partTitle}>
						<div className={s.label}>Тема оформления</div>
						<div className={s.subtitle}>Выбор сохраняется только на этом устройстве</div>
					</div>
					<div className={s.partForm}>
						<ThemeSwitcher />
					</div>
				</div>
			</div>
		</div>
	);
};
